import React from 'react';
import { connect } from 'react-redux';
import { Section, Title, Modal } from '@common/components';
import { popIn } from '@common/utils/services';
import ExpenseForm from '../Form';
import { createTransactionExpense } from '@common/resources/Transaction/actions';
import { useIntl } from 'react-intl';

const Create = (props) => {
	const { createTransactionExpense, visible, onCancel } = props;
	const intl = useIntl();

	const handleSubmit = (data) => {
		return createTransactionExpense(data)
			.then((response) => {
				popIn(
					'success',
					intl.formatMessage({
						id: 'message.success.expense.create',
						defaultMessage:
							'A new Expense has been successfully created',
					})
				);

				onCancel && onCancel();
			})
			.catch((err) => Promise.reject(err));
	};

	return (
		<Modal visible={visible} onCancel={() => onCancel && onCancel()}>
			<Title>
				{intl.formatMessage({
					id: 'common.new.expense',
					defaultMessage: 'Create Expense',
				})}
			</Title>
			<Section className="mb-5">
				<ExpenseForm onSubmit={handleSubmit} {...props} />
			</Section>
		</Modal>
	);
};

const mapStateToProps = ({
	items,
	modules,
	cellGroup,
	event,
	facility,
	ministry,
	mission,
	organization,
	prayer,
	testimony,
	service,
}) => {
	return {
		items,
		modules,
		cellGroup,
		event,
		facility,
		ministry,
		mission,
		organization,
		prayer,
		testimony,
		service,
	};
};

export default connect(mapStateToProps, {
	createTransactionExpense,
})(Create);
